import { render } from "./VTabs.vue?vue&type=template&id=0b9413ce&scoped=true"
import script from "./VTabs.vue?vue&type=script&lang=js"
export * from "./VTabs.vue?vue&type=script&lang=js"

import "./VTabs.vue?vue&type=style&index=0&id=0b9413ce&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9413ce"]])

export default __exports__